import { IconCircleCheck, IconCircleX, IconClock } from "@tabler/icons-react";

export interface StatusProps {
  name: string;
  position: string;
  status: number;
}

export default function StatusList({ statusList }: { statusList: StatusProps[] }) {
  const iconByStatus = (status: number | null, index: number) => {
    switch (status) {
      case 1:
        return (
          <div className="w-6 h-6 p-1 rounded-full bg-[#E5ECF0]">
            <div className="w-4 h-4 rounded-full bg-[#004369]"></div>
          </div>
        );

      case 2:
        return <IconCircleCheck className="text-[#74B710]" />;

      case 3:
        return <IconCircleX className="text-[#EF4343]" />;

      default:
        return (
          <div className="flex items-center justify-center w-6 h-6 p-1 rounded-full bg-[#FAFAFA]">
            <div className="text-xs font-semibold text-[#A3A3A3]">{index + 2}</div>
          </div>
        );
    }
  };

  const textByStatus = (status: number | null) => {
    switch (status) {
      case 1:
        return (
          <div className="flex items-center gap-1 text-[#004369]">
            <IconClock size={14} />
            <div className="text-sm">В работе</div>
          </div>
        );

      case 2:
        return "Завершено";

      case 3:
        return "Отклонено";

      default:
        return "Ожидает";
    }
  };

  const colorByStatus = (status: number | null) => {
    switch (status) {
      case 1:
        return "#004369";

      case 2:
        return "#74B710";

      case 3:
        return "#EF4343";

      default:
        return "#A3A3A3";
    }
  };

  return (
    <div className="status-list">
      <div className="status-item">
        <div className="status-body">
          <IconCircleCheck className="text-[#74B710]" />
          <div className="flex flex-col">
            <div className="text-base font-semibold text-[#18181B]">Создание заявки</div>
            <div className="text-sm text-[#74B710]">Завершено</div>
          </div>
        </div>
        <div className="status-line">
          <div className="bg-[#74B710]"></div>
        </div>
      </div>

      {statusList.map((status, idx) => (
        <div className="status-item" key={idx}>
          <div className="status-body">
            {iconByStatus(status.status, idx)}
            <div className="flex flex-col">
              <div className="text-base font-semibold text-[#18181B]">{status.position}</div>
              <div className={`text-sm text-[${colorByStatus(status.status)}]`}>{textByStatus(status.status)}</div>
            </div>
          </div>
          <div className="status-line">
            <div className={`bg-[${colorByStatus(status.status)}]`}></div>
          </div>
        </div>
      ))}
    </div>
  );
}
